import { render, staticRenderFns } from "./jmCom.vue?vue&type=template&id=72844900&scoped=true"
import script from "./jmCom.vue?vue&type=script&lang=js"
export * from "./jmCom.vue?vue&type=script&lang=js"
import style0 from "./jmCom.vue?vue&type=style&index=0&id=72844900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72844900",
  null
  
)

export default component.exports